export default {
  en: {
    title: 'Home',
    loadingLabel: 'Loading profile',
  },
  ru: {
    title: 'Главная',
    loadingLabel: 'Загружаем профиль',
  },
  de: {
    title: 'Start',
    loadingLabel: 'Profil wird geladen',
  },
  pt: {
    title: 'Início',
    loadingLabel: 'Carregando perfil',
  },
  fr: {
    title: 'Accueil',
    loadingLabel: 'Chargement du profil',
  },
  es: {
    title: 'Inicio',
    loadingLabel: 'Cargando perfil',
  },
};
